import React from 'react'

const galleryImages = [
  { src: 'images/foto-perfil.JPG', alt: 'trator' },
  { src: 'images/sala-agrosinal1.jpeg', alt: 'loja' },
  { src: 'images/sala-agrosinal2.jpeg', alt: 'loja' },
  { src: 'images/sala-agrosinal3.jpeg', alt: 'loja' },
  { src: 'images/foto1.jpeg', alt: 'Equipamento' },
  { src: 'images/foto.2.jpeg', alt: 'Equipamento' },
  {
    src: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&q=80',
    alt: 'Tecnologia'
  },
  { src: 'images/foto.4.jpeg', alt: 'Precisão' },
  {
    src: 'https://images.unsplash.com/photo-1473091534298-04dcbce3278c?w=600&q=80',
    alt: 'Antenas GPS'
  },
  {
    src: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&q=80',
    alt: 'Monitores'
  },
  { src: 'images/foto.7.jpg', alt: 'Tecnologia' },
  { src: 'images/foto.8.jpg', alt: 'Tecnologia' }
]

const Gallery = () => {
  return (
    <section className="gallery">
      <div className="container">
        <div className="section-header fade-in">
          <h2 className="section-title">Tecnologia em Ação</h2>
          <div className="section-subtitle">
            Somos referência em diagnóstico e manutenção de sistemas eletrônicos
            embarcados.
          </div>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div className="gallery-item fade-in" key={index}>
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Gallery
